export const Slider1Data = [
  {
    name: "MI 32 HD Ready Smart LED TV, 4A Horizon, ELA4546IN",
    img: "https://www.reliancedigital.in/medias/Mi-4A-Horizon-Edition-Television-492166368-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wxNjcxM3xpbWFnZS9qcGVnfGltYWdlcy9oNDcvaDk4Lzk3OTA4NzQ3MTQxNDIuanBnfDhjNDk4M2M1MTM1YTViZmFkMTY1NGM1ZmU4ZjFiODNiOGQ2NTMyYzUxYjg0NWJmYWE4MjIzODg4YmEzMWM5ZDY",
    price: "16,499.00",
    mrp: "19,999.00",
    discount: "18%(₹3,500)",
    id: 1,
  },
  {
    name: "IFFALCON 139.7 cm (55 Inch) Ultra HD (4K) Smart LED TV, 55U71",
    img: "https://www.reliancedigital.in/medias/Iffalcon-55U71-Television-493179244-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w0MjUyMXxpbWFnZS9qcGVnfGltYWdlcy9oZDMvaGM0Lzk4OTU3NzUwMTA4NDYuanBnfDhlMGU4MDEzNjUzZGNmYzM4ZTkzNTA2OGUwNDkyY2Y2ZTZkMzI5NzIyZjQzMzgzYzI1OTU0MTY5MGZjYTk5M2Y",
    price: "25,990.00",
    mrp: "70,990.00",
    discount: "63%(₹45,000)",
    id: 2,
  },
  {
    name: "Samsung Wondertainment 80 cm (32 Inch) Smart HD Ready TV, UA32T4340BKXXL",
    img: "https://www.reliancedigital.in/medias/Samsung-UA32T4340BKXXL-Smart-Television-492403650-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wyNDk1NnxpbWFnZS9qcGVnfGltYWdlcy9oNDcvaDE3Lzk4NDIyMDUxMzA3ODIuanBnfDljNDA4NjY5ZmYwYjNmMTBlMmYwZGEwODNkMTk5M2ZkMDc5MTgzZTAyY2VmNWYwMjJmYWNlZmEwNzBkNmYyZjI",
    price: "13,490.00",
    mrp: "22,900.00",
    discount: "41%(₹9,410)",
    id: 3,
  },
  {
    name: "Kodak 139 cm (55 inch) Ultra HD (4K) LED Smart TV, 7XPRO Series 55UHDX7XPRO, Quad Core Processor, Built-In Chromecast",
    img: "https://www.reliancedigital.in/medias/Kodak-55UHDX7XPRO-Television-492166145-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w3NDEyN3xpbWFnZS9qcGVnfGltYWdlcy9oYzIvaDNmLzk1MTE0Nzk2MDczMjYuanBnfGNkZjZkNTdlYWU4YmQ3YWM0MjU2MWY4OGNlNTBkZTM0YWIzOTQ1NTAwODFkYjkzODJjNGIxNzgwOWI4NzIyZmU",
    price: "24,999.00",
    mrp: "46,999.00",
    discount: "47%(₹22,000)",
    id: 4,
  },
  {
    name: "Sansui 80 cm (32 Inch) HD Ready Smart TV, Neo Series JSW32CSHD",
    img: "https://www.reliancedigital.in/medias/Sansui-JSW32CSHD-Television-493179126-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wzNzMxMnxpbWFnZS9qcGVnfGltYWdlcy9oYmMvaGRhLzk4OTI2OTQ1NTY3MDIuanBnfDNiNGIzMzY5MzI1NjE2YzA0MTlhMjNmY2JkNGE1MjBhMDFjZWI0ODBlMGRmZjU3NjIwMzI0YTJlNzlmMWI4MTQ",
    price: "8,999.00",
    mrp: "19,990.00",
    discount: "55%(₹10,991)",
    id: 5,
  },
  {
    name: "Kodak 80 cm (32 inch) HD Ready LED Smart TV, 7XPRO Series 32HDX7XPRO, Quad Core Processor, Built-in Chromecast",
    img: "https://www.reliancedigital.in/medias/Kodak-32HDX7XPRO-Televisions-492166141-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wyNjIzNHxpbWFnZS9qcGVnfGltYWdlcy9oZmQvaDgwLzk4OTQ2ODczNDI2MjIuanBnfDAxNzdkZTU5YWY0ZjdkMWFhN2NhM2E3ZDY4MjkwZjIzMGNkYjIzYzNkMDkyMTZlNWU3N2ViZTA2YTE4YzcxMzc",
    price: "9,999.00",
    mrp: "18,499.00",
    discount: "46%(₹8,500)",
    id: 6,
  },
  {
    name: "Hisense 108 cm (43 inch) 2Yr Warranty 4K Ultra HD Smart Certified Android LED TV 43A6GE (Black) with Dolby Vision and ATMOS",
    img: "https://www.reliancedigital.in/medias/HISENSE-43A6GE-Smart-LED-492338735-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w3NjY5OXxpbWFnZS9qcGVnfGltYWdlcy9oMTEvaDcwLzk3Nzg4NDI1OTk0NTQuanBnfGFiNzdlZmMxODczMmUyNzdlMDRkZGJjMzEyNTA4YTNhMGVhYjlhYmU0MzYwNDBmNmY4NjBlOGJjNDQwZjEzMjg",
    price: "19,990.00",
    mrp: "44,990.00",
    discount: "56%(₹25,000)",
    id: 7,
  },
  {
    name: "Hisense Vivid 80 cm(32 inch) HD Ready Smart LED TV, E4G, 32E4G",
    img: "https://www.reliancedigital.in/medias/Hisense-32E4G-Television-492912681-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w0MDM0NXxpbWFnZS9qcGVnfGltYWdlcy9oMTIvaGVlLzk4Mjk4NTgzNDQ5OTAuanBnfDIzYjlkNDkwNjgwYWViZWY0ZjgxZGI5Njk2MGJiYWNmNGU0MmExOGZlNjFhM2E3YTIyNGYxM2FmMzJmZWI5NmU",
    price: "10,990.00",
    mrp: "24,990.00",
    discount: "56%(₹14,000)",
    id: 8,
  },
  {
    name: "ONEPLUS 108 cm (43 inch) Full HD Smart LED TV, 43Y1",
    img: "https://www.reliancedigital.in/medias/ONEPLUS-43Y1-TV-491895011-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wyNTQ5NHxpbWFnZS9qcGVnfGltYWdlcy9oOGQvaDZmLzk4MTAwNTg1NzU5MDIuanBnfDRlNjk2MTc0MjNiODNmYmZkNmVjNWQwMjM1N2QxMzExOWFkNzcyOTNiY2M3ODU0ZmUyN2Y5OWEyNjExNzFkYTY",
    price: "21,999.00",
    mrp: "29,999.00",
    discount: "27%(₹8,000)",
    id: 9,
  },
  {
    name: "Hisense 80 cm (32 inch) 2Yr Warranty HD Smart LED TV with One Touch Access, Built-in Google Assistant (32A4G)",
    img: "https://www.reliancedigital.in/medias/Hisense-32A4G-Smart-Television-492338740-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w1NTUzMHxpbWFnZS9qcGVnfGltYWdlcy9oMzQvaGVkLzk3Nzk2NjE5NjMyOTQuanBnfGVkNTA5YWE2NmZlMjNhZTRmNzY1NzE4YjU0NGRhMzc4MjZhYjM0ZmFkMGEyMmE4YTBhZGM2ZWUzMzJiZGZmOTk",
    price: "13,490.00",
    mrp: "24,990.00",
    discount: "46%(₹11,500)",
    id: 10,
  },
];
export const Slider2Data = [
  {
    name: "LG 32 litres Convection Microwave Oven, MC3286BRUM",
    img: "https://www.reliancedigital.in/medias/581108139-Package-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w2NDI0OHxpbWFnZS9qcGVnfGltYWdlcy9oZjQvaDJmLzg5NjM4NDQ4OTg4NDYuanBnfDljZDk0MDcwYmFhNzQ1NjhlOTFiNzk3NjUyYmI3MzExZTU4NzA0MzYxMGRiMzg2ZmExN2RjMGZmMWJiMGIwM2Q",
    mrp: "23,999.00",
    price: "17,140.00",
    discount: "29%(₹6,859)",
    id: 1,
  },
  {
    name: "LG 28 litres Convection Microwave Oven, MC2846BV",
    img: "https://www.reliancedigital.in/medias/LG-MC2846BV-Microwave-Ovens-581107300-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wzODIzM3xpbWFnZS9qcGVnfGltYWdlcy9oOTkvaDFiLzk4MDU4NTQxNDY1OTAuanBnfDVlYWMxYTY5Nzk2OTkyYTcxZGEwOTVmY2FiYmQ0YmFmYTYwOGFmZTM0OGRjYjdjZTJlMGMxY2Q3MWY2ZGVjODc",
    mrp: "16,999.00",
    price: "15,990.00",
    discount: "6%(₹1,009)",
    id: 2,
  },
  {
    name: "IFB 30 litres Rotisserie Convection Microwave Oven, 30BRC2",
    img: "https://www.reliancedigital.in/medias/IFB-30BRC2-Microwave-Ovens-491391947-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wzODQ1OHxpbWFnZS9qcGVnfGltYWdlcy9oOTMvaGU4LzkwMTg4Nzk0NzU3NDIuanBnfDgxZGIxNGNlNGNkMDJkZDljMmU0ZTE5NGYxYmMzMDU1NzU0OTdlODg0Njc0NzdjMmY5YWJhNDZiNzQ5ZDAxMjQ",
    mrp: "20,390.00",
    price: "15,990.00",
    discount: "22%(₹4,400)",
    id: 3,
  },
  {
    name: "LG 20 litres Solo Microwave Oven, MS2043DB",
    img: "https://www.reliancedigital.in/medias/LG-MS2043DB-Microwave-Oven-491166959-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wxMzg4N3xpbWFnZS9qcGVnfGltYWdlcy9oMGIvaGYxLzkxOTY2NjQ5Nzk0ODYuanBnfDQyODU2MDc2MTZlODBjZjYyY2VlMjFlOTZlNjVjN2IyMzJmOTkxY2VhZTcwZTIxZDBhODU0YmNlNzIyZTQ5ZjM",
    mrp: "7,899.00",
    price: "6,499.00",
    discount: "18%(₹1,400)",
    id: 4,
  },
  {
    name: "Samsung 23 Litre Solo Microwave Oven with Indian Auto cook Menu, (MS23A3513AK/TL, Black)",
    img: "https://www.reliancedigital.in/medias/Samsung-MS23A3513AK-TL-Solo-Grill-492573240-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wxNzAyOXxpbWFnZS9qcGVnfGltYWdlcy9oZjIvaDY3Lzk4NDU0NjcxNTI0MTQuanBnfGUyMDczNjE2MTMzZDFlNWMyMmVjNzgxZmMzMTRhZmYzNDc1YmJmMzVmZDk0ZGYxMzI1ZTlhMTBmNTkxYzFkMzQ",
    mrp: "7,500.00",
    price: "6,600.00",
    discount: "12%(₹900)",
    id: 5,
  },
  {
    name: "LG 28 litres Convection Microwave Oven, MJ2886BWUM",
    img: "https://www.reliancedigital.in/medias/LG-MJ2886BWUM-Microwave-Ovens-491392151-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w0ODQ0N3xpbWFnZS9qcGVnfGltYWdlcy9oODUvaDRkLzg5Nzk4MTkzMzE2MTQuanBnfDQ5NjNkNTc2ODRjN2M0MzZhZTUzYTAyZjQ5MzljYjczNjEwNTQ4ODI2NjllMzQ4MTVjM2FkOWRhN2QxMmYwOWQ",
    mrp: "24,299.00",
    price: "19,490.00",
    discount: "20%(₹4,809)",
    id: 6,
  },
  {
    name: "LG 21 litres Convection Microwave Oven, MC2146BG",
    img: "https://www.reliancedigital.in/medias/LG-MC2146BG-Microwave-Ovens-491604223-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w1ODc4fGltYWdlL2pwZWd8aW1hZ2VzL2hlOS9oZDYvOTIyMDg4ODAwMjU5MC5qcGd8ZGI2OWEwYmFjNTM3MjQ2ZGI5ZmM5MTNiNDAxM2FlZWUzMzQ1NGQ3YmY4MzY3MWI1YTYyYmM5ZmM1ZmFkZmQyZA",
    mrp: "13,999.00",
    price: "11,590.00",
    discount: "17%(₹2,409)",
    id: 7,
  },
  {
    name: "Samsung 23 Litre Grill Microwave Oven with Grill Fry, Browning Plus (MG23A3515AK/TL, Black)",
    img: "https://www.reliancedigital.in/medias/Samsung-MG23A3515AK-TL-Solo-Grill-492573239-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wxNzA0NHxpbWFnZS9qcGVnfGltYWdlcy9oNTAvaDQwLzk4NDU0NjYxNjkzNzQuanBnfDgwZTgyN2Y2YTEwNjAzZDE2NmUwM2ZkNmIxNGQyMzlhNWRmYzk2NTk1MzU1ZTE1NzZiYmNmMjA4ZDg2OWNmYTQ",
    mrp: "11,600.00",
    price: "8,500.00",
    discount: "27%(₹3,100)",
    id: 8,
  },
  {
    name: "LG 32 litres Convection Microwave Oven, MJEN326UH",
    img: "https://www.reliancedigital.in/medias/LG-MJEN326UH-Microwave-Ovens-491604502-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w2Mjg3fGltYWdlL2pwZWd8aW1hZ2VzL2hjNS9oYTkvOTIyOTk4ODU2MDkyNi5qcGd8NzhmMjZiYWEzOGE3MDhhOTM2OWUyYWUwMzhlNjUzN2M5OTYzZTg0ZDhlOWU2MWUxMGQ4MDJiNjljNDg5MGM1Mg",
    mrp: "31,499.00",
    price: "24,490.00",
    discount: "22%(₹7,009)",
    id: 9,
  },
  {
    name: "Samsung 28 litres SlimFry Convection Microwave Oven, MC28A5033CK Black",
    img: "https://www.reliancedigital.in/medias/Samsung-MC28A5033CK-TL-Convection-MicrowaveOvens-492911130-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wzMDIzOXxpbWFnZS9qcGVnfGltYWdlcy9oYTMvaDRiLzk4ODc3MDc4MjQxNTguanBnfDhlMTVjNTVkZTYyZTgyYjY4N2E5NWE4NTMzNTMwZmJlYjNlMTJjMTI1Zjk0ODg0NDk2MmExODYzZWU1NmVhZGU",
    mrp: "17,990.00",
    price: "14,990.00",
    discount: "17%(₹3,000)",
    id: 10,
  },
];

export const Slider3Data = [
  {
    name: "Oppo Pad Air 26.31cm (10.36 inch) Tablet with 4 GB RAM, 128 GB Internal Storage, Black",
    img: "https://www.reliancedigital.in/medias/Oppo-PadAir-Tablet-493177063-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wxMDE3OHxpbWFnZS9qcGVnfGltYWdlcy9oMmMvaDNlLzk4NjQ0NDk3MjAzNTAuanBnfGI2NDU0NjE5NWI3NTE0M2Q5NjgyNzg5ZTg5MzhiOTk3ZmZlY2MwNjBkNDhkM2E5Zjc5MThmMDQ1NmVlNjk3ZTA",
    price: "19,999.00",
    mrp: "34,999.00",
    id: 1,
  },
  {
    name: "Nokia T20 26.42 cm (10.4 inch) LTE Tablet 4 GB RAM, 64 GB, Deep Ocean",
    img: "https://www.reliancedigital.in/medias/Nokia-NOKIA-T20-TA-1397-Tablet-492575359-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wxNTA1MHxpbWFnZS9qcGVnfGltYWdlcy9oMmQvaDMwLzk4MDkyOTc1MDYzMzQuanBnfDJjNWVlMjE2NjgyYzQwOGFjZjJkZmE2ODk3Y2ViNmNhYjA0MzYxMjg3ODk2MWE5NzNhMWI5NTE3MjFlZTdjMDU",
    price: "17,649.00",
    mrp: "21,999.00",
    id: 2,
  },
  {
    name: "Nokia T20 26.42 cm (10.4 inch) Wi-Fi Tablet 3 GB RAM, 32 GB, Deep Ocean",
    img: "https://www.reliancedigital.in/medias/Nokia-NOKIA-T20-TA-1392-Tablet-492575357-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wxNTA1MHxpbWFnZS9qcGVnfGltYWdlcy9oZmQvaGQyLzk4MDkyOTcxNzg2NTQuanBnfDg0YWU2MzY0NzQzMGMyNjIxNWFlZTE5YzBjY2VhMjg4MDE0YjRmN2NjOWQ3YTgzODQxMzY5Y2ViNGExMjUzN2U",
    price: "14,649.00",
    mrp: "17,999.00",
    id: 3,
  },
  {
    name: "Nokia T20 26.42 cm (10.4 inch) Wi-Fi Tablet 4 GB RAM, 64 GB, Deep Ocean",
    img: "https://www.reliancedigital.in/medias/Nokia-NOKIA-T20-TA-1392-Tablet-492575358-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wxNTA1MHxpbWFnZS9qcGVnfGltYWdlcy9oNjYvaDcyLzk4MDkyOTgxNjE2OTQuanBnfDhlZWQzMGEzZDcyMDllYjcwM2FiMTgzMDgwNGEwYjAwYmNmMDg1MTM1ZTA4NzE2Y2E3YzE1ZDQ4ZWM3NzU1YTQ",
    price: "15,649.00",
    mrp: "19,499.00",
    id: 4,
  },
  {
    name: "Realme Pad Mini 22.09 cm (8.7 inch) LTE Tablet 4 GB RAM, 64 GB, Grey RMP2105",
    img: "https://www.reliancedigital.in/medias/Realme-RMP2105-Regular-Tablets-492850319-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w2Mzc4NHxpbWFnZS9qcGVnfGltYWdlcy9oMmUvaGIwLzk4NDg5MDU0MzMxMTguanBnfDllM2E2MjY0ZjcyNGRlYTk2MTc5ODk5MDA3NzBlYmY3NGUzMDEyNWE0Mjc2ZmI1ZTdjOTEyYjBiZmRhMWUzZTg",
    price: "14,999.00",
    mrp: "23,999.00",
    id: 5,
  },
  {
    name: "Realme Pad Mini 22.09 cm (8.7 inch) LTE Tablet 4 GB RAM, 64 GB, Blue RMP2105",
    img: "https://www.reliancedigital.in/medias/Realme-RMP2105-Regular-Tablets-492850320-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w2MzEyNXxpbWFnZS9qcGVnfGltYWdlcy9oYzQvaGZmLzk4NDg5MDUxMDU0MzguanBnfDQ1NDc4YWI0MDJkM2QxOWI0N2UwNDliZmI0OWZjYTcxYTJhZWFjYzljZGU5YjU4NTBhMGQ3NGJjMTdmMTU1ZTc",
    price: "14,999.00",
    mrp: "23,999.00",
    id: 6,
  },
  {
    name: "Realme Pad Mini 22.09 cm (8.7 inch) LTE Tablet 3 GB RAM, 32 GB, Blue RMP2105",
    img: "https://www.reliancedigital.in/medias/Realme-RMP2105-Regular-Tablets-492850321-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w2MzQzNXxpbWFnZS9qcGVnfGltYWdlcy9oZjUvaGE5Lzk4NDg5MDU3NjA3OTguanBnfDE5M2ZiYzdjNTY5MGQ3Njg4YWZjNjE0ZWMxZjg3MDZiNzY0YTBlMTNiYjA1ODNiNWQxNjAwN2EzMWZlZWZiOTY",
    price: "11,999.00",
    mrp: "21,999.00",
    id: 7,
  },
  {
    name: "Realme Pad Mini 22.09 cm (8.7 inch) LTE Tablet 3 GB RAM, 32 GB, Grey RMP2105",
    img: "https://www.reliancedigital.in/medias/Realme-RMP2105-Regular-Tablets-492850322-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w2MzUxMnxpbWFnZS9qcGVnfGltYWdlcy9oNWUvaDQ5Lzk4NDg5MDQ3Nzc3NTguanBnfGZiMTY1YjAwZGQ5NjQ3ODBlZGU4NGFlZmNmMzMyODM2ZTQxMmVmZTQ0NjQzYjg4MGM5ZjhhMmNlMTIyZWFlYWQ",
    price: "11,999.00",
    mrp: "21,999.00",
    id: 8,
  },
  {
    name: "Realme Pad Mini 22.09 cm (8.7 inch) Wi-Fi Tablet 4 GB RAM, 64 GB, Grey RMP2106",
    img: "https://www.reliancedigital.in/medias/Realme-RMP2106-Regular-Tablets-492850315-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w2MzU0M3xpbWFnZS9qcGVnfGltYWdlcy9oYjkvaGYzLzk4NDg5MDM3OTQ3MTguanBnfDM0N2FkYzgzMzg1NjdiMjAwOGE2MGFlOTBmZjAzMGJjOTBjMDg0NzllMjMzMTU1OWRkNDFhODNlYzhmZDRhM2I",
    price: "12,999.00",
    mrp: "19,999.00",
    id: 9,
  },
  {
    name: "Realme Pad Mini 22.09 cm (8.7 inch) Wi-Fi Tablet 4 GB RAM, 64 GB, Blue RMP2106",
    img: "https://www.reliancedigital.in/medias/Realme-RMP2106-Regular-Tablets-492850316-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w2MzQ0NHxpbWFnZS9qcGVnfGltYWdlcy9oMTUvaDlkLzk4NDg5MDQxMjIzOTguanBnfGU5NmEzM2FkN2FhMjFlYjMyYzgzZTZlNzQxNTVhMmNiY2NkYTZlZGM0ZjQ4MGQ5YzA2ZDE0ZmFlNTA2NWE0MmE",
    price: "12,999.00",
    mrp: "19,999.00",
    id: 10,
  },
];


